module.exports = __webpack_public_path__ + "img/search.9df51d4e.svg";